import { Button } from '@tailark/core/ui/button'
import Link from 'next/link'
import type { CommonTranslations } from '../types/site-copy'

interface CallToActionProps {
    translations: CommonTranslations
    ctaHref: string
}

export default function CallToAction({ translations, ctaHref }: CallToActionProps) {
    const t = translations
    return (
        <section className="py-16 md:py-32">
            <div className="mx-auto max-w-5xl px-6">
                <div className="text-center">
                    <h2 className="text-balance text-4xl font-semibold lg:text-5xl">{t.callToAction.title}</h2>
                    <p className="mt-4">{t.callToAction.description}</p>
                    <div className="mt-12 flex flex-wrap justify-center gap-4">
                        <Button asChild size="lg">
                            <Link href={ctaHref}>
                                <span>{t.callToAction.buttonText}</span>
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    )
}
